<template>
  <router-view />
  <teleport to="body">
    <ConfirmationModal />
    <UpdateModal 
      v-model="showUpdateModal" 
      @reload="reloadNow"
      @remind-later="remindLater"
    />
  </teleport>
</template>

<script>
import { defineComponent } from 'vue';
import ConfirmationModal from '/src/Components/Modals/ConfirmationModal.vue'
import UpdateModal from '/src/Components/Modals/UpdateModal.vue'
import { datadogRum } from 'src/js/datadog.js';
import { getCurrentVersion } from 'src/js/api.js';
const { version } = require('../package.json');

export default defineComponent({
  name: 'App',
  components: { ConfirmationModal, UpdateModal },
  data() {
    return {
      showUpdateModal: false,
      reminderTimeout: null
    }
  },
  created() {
    this.fetchDeployedVersion();

    // Initialize Datadog RUM
    datadogRum.init({
      applicationId: '64fb3431-9c11-4d73-8453-f45a67454b6a',
      clientToken: 'pub159f96983d1323d3c113b2cd6c5de400',
      site: 'datadoghq.eu',
      service: process.env.HOST || 'wawican.de',
      env: process.env.VUE_APP_ENVIRONMENT || 'dev',
      version: version || '1.60.01',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackBfcacheViews: true,
      defaultPrivacyLevel: 'mask-user-input',
    });

  },
  beforeUnmount() {
    if (this.reminderTimeout) {
      clearTimeout(this.reminderTimeout);
    }
  },
  methods: {
    async fetchDeployedVersion() {
      console.log('Fetching deployed version');
      try {
        const deployedVersion = await getCurrentVersion();
        const currentVersion = process.env.APP_VERSION || '';
        
        this.$store.dispatch('options/deployedVersion', deployedVersion || null);
        console.log('Deployed version:', deployedVersion);
        
        if (deployedVersion && currentVersion && deployedVersion !== currentVersion) {
          this.showUpdateModal = true;
        }
      } catch (error) {
        console.error('Error fetching deployed version:', error);
        this.$store.dispatch('options/deployedVersion', null);
      }
    },
    async reloadNow() {
      try {
        if ('serviceWorker' in navigator) {
          const registrations = await navigator.serviceWorker.getRegistrations();
          await Promise.all(registrations.map(registration => registration.unregister()));
        }
        
        if ('caches' in window) {
          const cacheNames = await caches.keys();
          await Promise.all(cacheNames.map(name => caches.delete(name)));
        }
        
        await new Promise(resolve => setTimeout(resolve, 100));
      } catch (error) {
        console.error('Error clearing caches/service workers:', error);
      } finally {
        const url = new URL(window.location.href);
        url.searchParams.set('_t', Date.now());
        window.location.replace(url.toString());
      }
    },
    remindLater() {
      if (this.reminderTimeout) {
        clearTimeout(this.reminderTimeout);
      }
      
      this.reminderTimeout = setTimeout(() => {
        this.showUpdateModal = true;
      }, 60000);
    }
  }
})
</script>
